import { Helmet } from 'react-helmet-async';
import { Box, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { DealerPageHeaderEntityInfo } from 'app/components/ReusableUIComponents/LowLevelComponents/PageHeaderEntityInfo';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { CONFIGURE_RESOURCE_CDP_SETTINGS } from 'app/pages/ConfigurePage/utils/configureResourceIds';
import { CRMSettingsComponent } from 'app/pages/CRMSettingsComponent/Loadable';
import { CrmEmailMailgunRouteSettingsComponent } from 'app/pages/CrmEmailMailgunRouteSettingsComponent/Loadable';
import { CdpRawDataUploadSection } from 'app/pages/RunLogsPage/components/CdpRawDataUploadSection';
import { DataIngestionProvider } from 'app/context/DataIngestionContext';
import { RunLogsProvider } from 'app/context/RunLogsContext';

import { useCdpSettingsConfigurationPage } from './hooks/useCdpSettingsConfigurationPage';

const CdpSettingsConfigurationPage = () => {
  const history = useHistory();
  const { breadcrumbsList, returnTo, hasDealer, dealerTitle, dealerId } =
    useCdpSettingsConfigurationPage();

  return (
    <>
      <Helmet>
        <title>CDP Settings</title>
        <meta
          name="description"
          content="Configure CRM and upload CDP raw data for the selected dealership"
        />
      </Helmet>
      <DataIngestionProvider>
        <RunLogsProvider>
          <DealerRequiredPageShell
            hasDealer={hasDealer}
            breadcrumbsList={breadcrumbsList}
            pageTitle="CDP Settings"
            headerSubtitle={
              hasDealer ? (
                <DealerPageHeaderEntityInfo
                  title={dealerTitle}
                  dealerId={dealerId}
                />
              ) : undefined
            }
            contentVariant="centered"
          >
            <Box
              data-guidance-tour="configure-cdp-settings-page"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                width: '100%',
              }}
            >
              {returnTo ? (
                <Box>
                  <Button
                    variant="text"
                    onClick={() => history.push(returnTo)}
                    sx={{ textTransform: 'none', px: 0 }}
                  >
                    Back to Nurturing Plan Generator
                  </Button>
                </Box>
              ) : null}
              <CRMSettingsComponent />
              <CrmEmailMailgunRouteSettingsComponent />
              <CdpRawDataUploadSection />
            </Box>
          </DealerRequiredPageShell>
        </RunLogsProvider>
      </DataIngestionProvider>
    </>
  );
};

export default withResourceProtection(
  CdpSettingsConfigurationPage,
  CONFIGURE_RESOURCE_CDP_SETTINGS,
);
